import { DETALLE_SUCURSAL,UPDATE_TITLE } from "./actionTypes";

const initialState = {
  detalle_sucursal: {
    insumos:false,
    movimiento:false,
    update:false,
    delete:false,
    save:false
  },
  titulo:''
};

const titles = (state = initialState, action) => {
  switch (action.type) {
    case DETALLE_SUCURSAL:
      const newState = {
        ...state,
        detalle_sucursal: action.payload
      };
      return newState;
    case UPDATE_TITLE:
      const updateState = {
        ...state,
        titulo: action.payload
      };
      return newState;
    default:
      return state;
  }
};

export default titles;
